import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from "../ui/dialog";

interface VideoPlayerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  video: any;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  open,
  onOpenChange,
  video
}) => {
  if (!video) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>{video?.title || "Video"}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video w-full overflow-hidden rounded-md">
          {video && (
            video?.includes('youtube.com') || video?.includes('youtu.be') ? (
              <iframe
                width="100%"
                height="100%"
                src={video?.replace('watch?v=', 'embed/')}
                title={video?.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute-center"
              ></iframe>
            ) : (
              <video
                controls
                className="w-full h-full"
                src={video}
                title={video?.title}
              ></video>
            )
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};